<template>
    <div class="container mescroll-touch">
        <!-- <img src="../../assets/images/zhibotop.png" class="img" /> -->
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="wait">敬请期待！</div>
        <!-- <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/contacticon.png" class="modeltitleimg" />
                    <div class="modeltitletext">注册组</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name"><span class="perplebold">团体:</span>刘老师&nbsp;15800797187</div>
                <div class="name1"><span class="perplebold">个人:</span>代用名&nbsp;xxxxxxxxxxx</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/contacticon.png" class="modeltitleimg" />
                    <div class="modeltitletext">嘉宾组</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">代用名&nbsp;xxxxxxxxxxx</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/contacticon.png" class="modeltitleimg" />
                    <div class="modeltitletext">征文投稿</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">代用名&nbsp;xxxxxxxxxxx</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/contacticon.png" class="modeltitleimg" />
                    <div class="modeltitletext">展商合作</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">代用名&nbsp;xxxxxxxxxxx</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/contacticon.png" class="modeltitleimg" />
                    <div class="modeltitletext">会务组</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">代用名&nbsp;xxxxxxxxxxx</div>
            </div>
        </div> -->
        <floatback></floatback>
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'zhineng',
    data() {
        return {
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initacmedShare();
        document.title = "ACMED第一届学术年会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(179, 178, 255);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: #b3b2ff;
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: 1rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(177, 172, 255);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.name {
    width: 50%;
    // text-align: center;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.name1 {
    width: 50%;
    text-align: right;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.perplebold {
    color: #8483d1;
    font-weight: bold;
}

.wait {
    text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .55rem;
    padding-top: 20%;
}
</style>